import { Navigate, Route, Routes } from "react-router-dom";
import { SignInPage } from "./pages/SignInPage";
import { DashboardPage } from "./pages/DashboardPage";
import { BriefPage } from "./pages/BriefPage";
import { AdminUserDetailPage } from "./pages/AdminUserDetailPage";
import { AdminBusinessDetailPage } from "./pages/AdminBusinessDetailPage";
import { Layout } from "./components/Layout";
import { InstallPrompt } from "./components/InstallPrompt";
import { useUser } from "./hooks/useUser";

function RootRedirect() {
  const { user, loading } = useUser();
  if (loading) return null;
  return <Navigate to={user ? "/dashboard" : "/signin"} replace />;
}

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/admin/users/:id" element={<AdminUserDetailPage />} />
        <Route path="/admin/businesses/:id" element={<AdminBusinessDetailPage />} />
        <Route path="/brief/:businessId" element={<BriefPage />} />
      </Routes>
      <InstallPrompt />
    </Layout>
  );
}
